/* MEDIA PLAYER ITEM **********************************************************/
import React, {Component, PropTypes} from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'
import moment from 'moment'

/* Components */
import MediaPlayerSurface from 'component/media-player/surface'
import MediaPlayerSnapshot from 'component/media-player/snapshot'

/* Widgets */
import TextInput from 'widget/text-input'
import TagInput from 'widget/tag-input'
import DropdownButton from 'widget/dropdown-button'
import { Highlight, MODE as HIGHLIGHT_MODE } from 'widget/highlight'
import {
  RemoveDialog,
  SCHEME as REMOVE_DIALOG_SCHEME
} from 'widget/remove-dialog'
import InfoText from 'widget/info-text'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

/* Actions */
import { showModal, hideModal } from 'react-redux/actions/modal'
import { expand, collapse, fetchExpanded } from 'react-redux/actions/media-player'
import {
  editItem,
  saveName,
  saveDescription,
  saveTags,
  syncSurfaces,
  syncMediaPlayer
} from 'react-redux/actions/media-player'
import {
  fetchGraphicsOutput,
  fetchCameraImage,
  setUID
} from 'react-redux/actions/media-player'
import { assignGlobalPlaylist, wrapAssetAndAssignGlobalPlaylist } from 'react-redux/actions/surface'
import { select } from 'react-redux/actions/highlight'

/* Selectors */
import { getItem } from 'react-redux/selectors/media-player'
import { getDragAndDrop } from 'react-redux/selectors/drag-and-drop'

/* Styles */
import './item.css'

/* A single MediaPlayer Device Item as shown in Media Player List */
class MediaPlayerItem extends Component {

  constructor(props) {
    super(props)
    this.state = { isDropTarget: false, syncCommit: false }
    this.dragEnterCount = 0
  }

  componentDidMount() {
    const { fetchExpanded, uid } = this.props
    if(!uid) return
    fetchExpanded(uid)
  }

  componentWillReceiveProps(nextProps) {
    const { uid } = this.props
    if (!nextProps.uid || nextProps.uid === uid) return
    fetchExpanded(nextProps.uid)
  }

  onSaveName(value) {
    const { uid, saveName } = this.props
    saveName(uid, value)
  }

  onEditName() {
    const { select, uid } = this.props
    select("mediaplayer", uid)
  }

  validateName(value) {
    return true
  }

  onSaveDescription(value) {
    const { uid, saveDescription } = this.props
    saveDescription(uid, value)
  }

  onEditDescription() {
    const { select, uid } = this.props
    select("mediaplayer", uid)
  }

  validateDescription(value) {
    return true
  }

  onSaveTags(tags) {
    const { uid, saveTags } = this.props
    saveTags(uid, tags)
  }

  onEditTags() {
    const { select, uid } = this.props
    select("mediaplayer", uid)
  }

  showGraphicsOutputModal(e) {
    const {
      uid,
      fetchGraphicsOutput,
      showModal,
      //setSnapshotUID
    } = this.props
    e.stopPropagation() // cancel event bubbling
    //setSnapshotUID(uid)
    fetchGraphicsOutput(uid)
    showModal(<MediaPlayerSnapshot />)
  }

  showCameraModal(e) {
    const {
      uid,
      fetchCameraImage,
      showModal,
      //setSnapshotUID
    } = this.props
    e.stopPropagation() // cancel event bubbling
    //setSnapshotUID(uid)
    fetchCameraImage(uid)
    showModal(<MediaPlayerSnapshot />)
  }


  syncSurfaces(e) {
    const { uid, syncSurfaces } = this.props
    e.stopPropagation() // cancel event bubbling
    syncSurfaces(uid)
  }

  onDrop(e) {
    const { uid, assignGlobalPlaylist, wrapAssetAndAssignGlobalPlaylist } = this.props
    e.preventDefault()
    try {
      const data = JSON.parse(e.dataTransfer.getData('text'))
      if(data.domain === "playlist") {
        assignGlobalPlaylist(uid, data.uid)
      } else if (data.domain === "asset") {
        wrapAssetAndAssignGlobalPlaylist(uid, data.uid)
      }
    } catch (e) {
      return
    }
    this.setState({isDropTarget: false})
  }

  onDragEnter(e) {
    const { domain } = this.props.dragAndDrop
    e.preventDefault()
    e.stopPropagation()
    if (domain === 'asset' || domain === 'playlist') {
      this.setState({isDropTarget: true})
    } else {
      this.setState({isDropTarget: false})
    }
  }

  onDragOver(e) {
    const { domain } = this.props.dragAndDrop
    e.preventDefault()
    e.stopPropagation()
    if (domain === 'asset' || domain === 'playlist') {
      this.setState({isDropTarget: true})
    } else {
      this.setState({isDropTarget: false})
    }
  }

  onDragLeave(e) {
    e.preventDefault()
    this.setState({isDropTarget: false})
  }

  isSelected() {
    const { domain, uid } = this.props.highlight
    return domain === "mediaplayer" && uid === this.props.uid
  }

  isAscendant() {
    const { ascendants } = this.props.highlight
    return ascendants["mediaplayer"]
      && ascendants["mediaplayer"][this.props.uid]
  }

  isDescendant() {
    const { descendants } = this.props.highlight
    return descendants["mediaplayer"]
      && descendants["mediaplayer"][this.props.uid]
  }

  getListItemClass() {
    const { } = this.props
    const { isDropTarget } = this.state
    var className = "media-player-item component"
    if (this.isSelected()) className += " highlight-selected"
    else if (this.isAscendant()) className += " highlight-ascendant"
    else if (this.isDescendant()) className += " highlight-descendant"
    if (isDropTarget) className += " drop-target"
    return className
  }

  onSyncMediaPlayerClick(e) {
    e.stopPropagation()
    this.setState({
      syncCommit: true
    })
  }

  syncMediaPlayer(e) {
    const { syncMediaPlayer, uid} = this.props
    e.stopPropagation()
    syncMediaPlayer(uid)
    hideModal()
  }

  onSyncCommitClick(e) {
    const { syncMediaPlayer, uid } = this.props
    e.stopPropagation()
    syncMediaPlayer(uid)
    this.setState({
      syncCommit: false
    })
  }

  onSyncCancelClick(e) {
    e.stopPropagation()
    this.setState({
      syncCommit: false
    })
  }

  measureHeight() {
    if(!this.deviceElement) return null
    const bounds = this.deviceElement.getBoundingClientRect()
    return bounds.height
  }

  renderSyncCommit() {
    const { t, metaData } = this.props
    const { name } = metaData
    const { syncCommit } = this.state
    if (!syncCommit) return null
    return (
      <RemoveDialog
        text={ t("mediaplayer:item.syncDialog.text", {name}) }
        height={ this.measureHeight() }
        scheme={ REMOVE_DIALOG_SCHEME.ACTION }
        onCancel={ this.onSyncCancelClick.bind(this) }
        cancelLabel={ t("mediaplayer:item.syncDialog.cancelButtonLabel") }
        onConfirm={ this.onSyncCommitClick.bind(this) }
        confirmLabel={ t("mediaplayer:item.syncDialog.confirmButtonLabel") }
      />
    )
  }

  renderChange() {
    const { t, status, lastSuccessfullSync, surfaces, uid } = this.props
    let syncHint = false
    for (let k in surfaces) {
      if (new Date(surfaces[k].timeModified) > new Date(lastSuccessfullSync)) {
        syncHint = true
      }
    }
    const online = status?status.online:false
    if (syncHint){
      return (
        <Icon
          className="change-icon"
          title={ t("mediaplayer:item.syncRequired") }
          icon={ ICON.SYNC }
          size={ 20 }
          circle={ true }
          scheme={ ICON_SCHEME.WARNING }
        />
      )
    } else {
      return null
    }
  }

  renderEdgeDSStatus() {
    const { t, status, uid, syncing, provisioning } = this.props
    const online = status?status.online:false
    if (online && syncing) {
      return (
        <div className="status-wrapper">
          <Icon
            className="online-icon"
            title={ t("mediaplayer:item.isSyncing") }
            icon={ ICON.LOADING_SYNC }
            size={ 32 }
            circle={ true }
            spin={ true }
            scheme={ ICON_SCHEME.ACTION }
            />
          { this.renderChange() }
        </div>
      )
    } else if (online) {
      return (
        <div className="status-wrapper">
          <Icon
            className="online-icon"
            title={ t("mediaplayer:item.isOnline") }
            icon={ ICON.ONLINE }
            size={ 32 }
            circle={ true }
            scheme={ ICON_SCHEME.READY }
            />
          { this.renderChange() }
        </div>
      )
    } else {
      return (
        <div className="status-wrapper">
          <Icon
            className="online-icon"
            title={ t("mediaplayer:item.isOffline") }
            icon={ ICON.OFFLINE }
            size={ 32 }
            circle={ true }
            scheme={ ICON_SCHEME.DANGER }
            />
          { this.renderChange() }
        </div>
      )
    }
  }

  renderEdgeCashRegisterStatus() {
    const { t, status, uid, syncing, provisioning } = this.props
    return (
      <div className="status-wrapper">
        <Icon
          className="online-icon"
          title={ t("mediaplayer:item.cashRegister") }
          icon={ ICON.CASH_REGISTER }
          size={ 32 }
          circle={ true }
          scheme={ ICON_SCHEME.READY }
          />
      </div>
    )
  }

  renderEdgePWAStatus() {
    const { t, status, uid, syncing, provisioning } = this.props
    return (
      <div className="status-wrapper">
        <Icon
          className="online-icon"
          title={ t("mediaplayer:item.edgePWA") }
          icon={ ICON.CASH_REGISTER }
          size={ 32 }
          circle={ true }
          scheme={ ICON_SCHEME.READY }
          />
      </div>
    )
  }

  renderEdgeAndroidStatus() {
    const {
      t,
      status,
      uid,
      syncing,
      provisioning,
      lastSuccessfullSync
    } = this.props
    //console.log(lastSuccessfullSync)

    let scheme = ICON_SCHEME.READY
    let icon = ICON.EDGE_ANDROID_ONLINE
    if (moment(lastSuccessfullSync).isBefore(Date.now() - 30 * 60 * 1000)) {
      scheme = ICON_SCHEME.DANGER
      icon = ICON.EDGE_ANDROID_OFFLINE
    }
    return (
      <div className="status-wrapper">
        <Icon
          className="online-icon"
          title={ t("mediaplayer:item.edgeAndroid") }
          icon={ icon }
          size={ 32 }
          circle={ true }
          scheme={ scheme }
          />
      </div>
    )
  }

  renderStatus() {
    const { t, status, uid, syncing, provisioning } = this.props
    switch (provisioning.deviceType) {
      case "edge-ds":
      case "edge-play":
        return this.renderEdgeDSStatus()
      case "edge-android":
        return this.renderEdgeAndroidStatus()
      case "edge-web-bat":
        return this.renderEdgeCashRegisterStatus()
      case "edge-pwa":
      default:
        return this.renderEdgePWAStatus()
    }

  }

  renderSurfaces() {
    const { surfaceList, uid } = this.props
    return (
      _.map(surfaceList, (surface, index) => {
        return (
          <MediaPlayerSurface
            key={ surface.uid }
            uid={ surface.uid }
            mediaPlayerId={ uid }
          />
        )
      })
    )
  }

  toggleCollapse(e) {
    const { uid, expanded, expand, collapse } = this.props
    e.stopPropagation()
    if (!expanded) expand(uid)
    else collapse(uid)
  }

  isCollapsed() {
    const { expanded } = this.props
    return !expanded
  }

  renderSurfaceSection() {
    if (this.isCollapsed()) return null
    return (
      <div className="channel">
        <ul className="channel-list">
          { this.renderSurfaces() }
        </ul>
      </div>
    )
  }

  renderToggleCollapseButton() {
    const { t, uid, surfaces } = this.props
    if (!surfaces || !_.size(surfaces)) return null
    if (this.isCollapsed()) return (
      <button
        value={ uid }
        className="icon"
        title={ t("mediaplayer:item.expand") }
        onClick={ this.toggleCollapse.bind(this) }>
        <Icon icon={ ICON.CARET_DOWN } size={ 24 } circle={ false } />
      </button>
    )
    return (
      <button
        value={ uid }
        className="icon"
        title={ t("mediaplayer:item.collapse") }
        onClick={ this.toggleCollapse.bind(this) }>
        <Icon icon={ ICON.CARET_UP } size={ 24 } circle={ false } />
      </button>
    )
  }

  getToolbarItems() {
    const { t, status, uid, provisioning, lastSuccessfullSync, surfaces }  = this.props
    let syncHint = false
    for (let k in surfaces) {
      if (new Date(surfaces[k].timeModified) > new Date(lastSuccessfullSync)) {
        syncHint = true
      }
    }
    const online = status?status.online:false
    let items = []
    if(
      provisioning.deviceType === "edge-ds"
      || provisioning.deviceType === "edge-play"
    ) {
      items.push(
        {
          name: t("mediaplayer:item.menu.syncSurfacesLabel"),
          title: t("mediaplayer:item.menu.syncSurfacesTitle"),
          icon: ICON.SYNC_IMPORT,
          onClick: this.syncSurfaces.bind(this)
        },
        {
          name: t("mediaplayer:item.menu.syncMediaPlayerLabel"),
          title: t("mediaplayer:item.menu.syncMediaPlayerTitle"),
          icon: ICON.SYNC,
          iconScheme: (syncHint)?ICON_SCHEME.WARNING: ICON_SCHEME.DEFAULT,
          onClick: this.onSyncMediaPlayerClick.bind(this)
        }
      )
      if(online) {
        items.push(
          {
            name: t("mediaplayer:item.menu.graphicsOutputLabel"),
            title: t("mediaplayer:item.menu.graphicsOutputTitle"),
            icon: ICON.GRAPHICS_OUTPUT,
            onClick: this.showGraphicsOutputModal.bind(this)
          },
          {
            name: t("mediaplayer:item.menu.cameraLabel"),
            title: t("mediaplayer:item.menu.cameraTitle"),
            icon: ICON.CAMERA,
            onClick: this.showCameraModal.bind(this)
          }
        )
      } else {
        items.push({
          name: t("mediaplayer:item.menu.isOfflineLabel"),
          title: t("mediaplayer:item.menu.isOfflineTitle"),
          icon: ICON.PROHIBITED,
          iconScheme: ICON_SCHEME.WARNING
        })
      }
      items.push({ type: "seperator" })
    }
    items.push({
      name: uid,
      title: t("mediaplayer:item.menu.edgeId"),
      style: "info"
    })
    items.push({
      name: provisioning.deviceType,
      title: t("mediaplayer:item.menu.deviceType"),
      style: "info"
    })
    items.push({
      name: lastSuccessfullSync,
      title: t("mediaplayer:item.menu.lastSync"),
      style: "info"
    })
    items.push({
      name: moment(lastSuccessfullSync).fromNow(),
      title: t("mediaplayer:item.menu.timeSinceLastSync"),
      style: "info"
    })
    return items
  }

  renderItemToolbar() {
    const { t } = this.props
    return (
      <span className="toolbar">
        <DropdownButton
          title={ t('mediaplayer:item.menuTitle') }
          menu={ { items:this.getToolbarItems() } }/>
          { this.renderToggleCollapseButton() }
      </span>
    )
  }

  getHighlightMode() {
    const { } = this.props
    if (this.isSelected()) return  HIGHLIGHT_MODE.SELECTED
    else if (this.isAscendant()) return  HIGHLIGHT_MODE.CHILD
    else if (this.isDescendant()) return  HIGHLIGHT_MODE.PARENT
  }

  render() {
    const {
      t,
      uid,
      metaData,
      select
    } = this.props
    const {
      name,
      description,
      tags,
    } = metaData

    return (
      <li
        className={ this.getListItemClass() }
        key={ uid }
        data-uid={ uid }
      >
        <div
            className="device"
            ref={ (elem) => { this.deviceElement = elem } }
            onClick={ (e) => { select("mediaplayer", uid) } }
            onDragEnter={ this.onDragEnter.bind(this) }
            onDragOver={ this.onDragOver.bind(this) }
            onDragLeave={ this.onDragLeave.bind(this) }
            onDrop={ this.onDrop.bind(this) }
        >
          <div className="border">
            <div className="detail">
              <Highlight mode={ this.getHighlightMode() } />
              <div className="status">
                { this.renderStatus() }
              </div>
              <div className="label">
                <TextInput
                  className="name"
                  value={ name }
                  placeholder={ t('mediaplayer:item.nameInput.placeholder') }
                  onSave={ this.onSaveName.bind(this) }
                  onEdit={ this.onEditName.bind(this) }
                  validate={ this.validateName.bind(this) }
                  clearTitle={ t("input:clearTitle")}
                  resetTitle={ t("input:resetTitle")}
                  saveTitle={ t("input:saveTitle")}
                />
                <TextInput
                  className="description"
                  value={ description }
                  placeholder={
                    t('mediaplayer:item.descriptionInput.placeholder')
                  }
                  onSave={ this.onSaveDescription.bind(this) }
                  onEdit={ this.onEditDescription.bind(this) }
                  validate={ this.validateDescription.bind(this) }
                  clearTitle={ t("input:clearTitle")}
                  resetTitle={ t("input:resetTitle")}
                  saveTitle={ t("input:saveTitle")}
                />
                <TagInput
                  value={ tags || [] }
                  placeholder={ t('mediaplayer:item.tagInput.placeholder') }
                  onSave={ this.onSaveTags.bind(this) }
                  onEdit={ this.onEditTags.bind(this) }
                  clearTitle={ t("input:clearTitle")}
                  resetTitle={ t("input:resetTitle")}
                  saveTitle={ t("input:saveTitle")}
                ></TagInput>
              </div>
              { this.renderItemToolbar() }
            </div>
          </div>

        </div>
        { this.renderSurfaceSection() }
        { this.renderSyncCommit() }
      </li>
    )
  }
}

MediaPlayerItem.propTypes =  {
  uid: PropTypes.string.isRequired,
}

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showModal,
      hideModal,
      editItem,
      expand,
      collapse,
      fetchExpanded,
      fetchGraphicsOutput,
      fetchCameraImage,
      setSnapshotUID: setUID,
      assignGlobalPlaylist,
      wrapAssetAndAssignGlobalPlaylist,
      syncSurfaces,
      syncMediaPlayer,
      saveName,
      saveDescription,
      saveTags,
      select
    },
    dispatch
  )
}

function mergeProps(stateProps, dispatchProps, ownProps){
  return Object.assign(
    {},
    dispatchProps,
    getItem(stateProps, ownProps.uid),
    { dragAndDrop: getDragAndDrop(stateProps) },
    { highlight: stateProps.highlight },
    ownProps
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(MediaPlayerItem)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/media-player/item.jsx